import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/account"

export function accountByInvoiceId(param) {
  return request({
    url: prefix + '/invoiceId',
    method: 'post',
    data: param,
  })
}
export function cancelAccountByInvoiceId(invoiceId) {
  return request({
    url: prefix + '/cancel/invoiceId/' + invoiceId,
    method: 'get'

  })
}

export function accountByQrCode(param) {
  return request({
    url: prefix + '/qrcode',
    method: 'post',
    data: param,
  })
}
export function cancelAccountByQrCode(qrcode) {
  return request({
    url: prefix + '/cancel/qrcode/' + qrcode,
    method: 'get',

  })
}

export function expenseByInvoiceId(param) {
  return request({
    url: prefix + '/expense/invoiceId',
    method: 'post',
    data: param,
  })
}

export function cancelExpenseByInvoiceId(invoiceId) {
  return request({
    url: prefix + '/expense/cancel/invoiceId/' + invoiceId,
    method: 'get'

  })
}
